import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, useLocation } from 'react-router-dom';
import ApiService from '../../services/apiService';
import Select from 'react-select';
import React, { useState, useEffect } from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import moment from 'moment';
import { toast } from 'react-toastify';
import { ClipLoader } from 'react-spinners';
import { useDispatch, useSelector } from 'react-redux';
import { getName, getUserName } from '../../../Redux/selecters';
import { RiRefreshLine } from "react-icons/ri";
import { FaAngleLeft } from "react-icons/fa6";
import { FaSave } from "react-icons/fa";
import { clearRows } from '../../../Redux/actions/rowActions';
import Pagination from '../pagination/pagination';
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';
import { IoSearch } from "react-icons/io5";
import { IoAddSharp } from 'react-icons/io5';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
const REPORT_URL = process.env.REACT_APP_REPORTS_URL;

const PartialPO = () => {
    let navigate = useNavigate()
    const location = useLocation()
    const apiService = new ApiService()
    let dispatch = useDispatch()
    const [DocTerm, setDocTerm] = useState()
    const userName = useSelector(getUserName)
    const [rowData, setRowData] = useState([])
    const [pageSize, setPageSize] = useState(20)
    const [pagination, setPagination] = useState()
    const [SupplierTab, setSupplierTab] = useState(true)
    const [permissions, setPermissions] = useState([])
    const [loading, setLoader] = useState(false)
    const [POTab, setPOTab] = useState(true)
    const [suppliers, setSupplier] = useState([]);


    const formatDate = (date) => {
        return moment(date).format("DD-MMM-YYYY");
    };

    useEffect(() => {
        const storedPermissions = JSON.parse(localStorage.getItem('RoleAccess')) || [];
        const permissions = storedPermissions?.filter(acc => acc.formName === "Approval");
        setPermissions(permissions[0]);
        const today = new Date();

        setFormData((prev) => ({
            ...prev,
            fromDate: formatDate(today),
            toDate: formatDate(today),
        }));
        fetchData()
    }, []);
    const [formData, setFormData] = useState({
        DocType: "",
        fromDate: '',
        toDate: '',
        DocumentNo: "",
        filter: '',
        vendorName: "",
    })
    const DocFilter = [
        { value: 'All', label: 'All' },
        { value: 'Cancelled', label: 'Cancelled' },
        { value: 'Closed', label: 'Closed' },
    ]
    const fetchData = async (newPageNo = pagination?.currentPage) => {
        try {
            const response = await apiService.get('GET_SUPPLIER');
            setSupplier(response?.data?.result);
        } catch (error) {
            console.error("Error fetching stock data:", error);
        }
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [e.target.name]: e.target.value });
    }
    const handleSupplierChange = (selectedOption) => {
        setFormData({ ...formData, vendorName: selectedOption });
    };
    const fetchApprovalData = async (newPageNo = pagination?.currentPage) => {
        try {
            setLoader(true)
            const params = new URLSearchParams();
            params.append('PageNo', newPageNo || 1);
            params.append('PageSize', pageSize || 20);
            params.append('DocNumber', formData?.DocumentNo || '');
            params.append('FromDate', formData?.fromDate || '');
            params.append('ToDate', formData?.toDate || '');
            params.append('VendorId', formData?.vendorName?.value?.supplier_ID || '');
            params.append('DocType', DocTerm?.value || 'All');
            const response = await apiService.getApiParamater('GET_CANCEL_PO', `?${params.toString()}`);
            if (response?.data?.statusCode === 200) {
                const Authorization = response?.data?.result;
                setRowData(Authorization.reverse());
                setPagination(response.data.paginationData);
                setLoader(false)
            } else if (response?.data?.statusCode === 204) {
                setRowData([]);
                setLoader(false)
            }

        } catch (error) {
            setLoader(false)
            console.error("Error fetching packing data:", error);
        }
    }
    const handleDocFilter = (selectedOption) => {
        setDocTerm(selectedOption);
    }
    const [colDefs, setColDefs] = useState([
        { headerName: "PO No", field: "pOrderNo", suppressMovable: true, width: 150, },
        { headerName: "Vendor Id", field: "vendorId", suppressMovable: true, width: 170 },
        { headerName: "Vendor Name", field: "vendorName", suppressMovable: true, width: 350 },
        { headerName: "Doc Date", field: "docDate", suppressMovable: true, width: 120 },
        { headerName: "Delivery Date", field: "deliveryDate", suppressMovable: true, width: 120 },
        { headerName: "Location", field: "location", suppressMovable: true, width: 200 },
        { headerName: "Property", field: "costCenter1", suppressMovable: true, width: 250 },
        {
            headerName: "Print", field: "", suppressMovable: true, width: 150, cellRenderer: (params) => {
                const { doctype } = params.data;
                const handleButtonClick = () => handlePrint(params.data?.pOrderNo);
                const buttonStyle = {
                    color: '#1032E7',
                    textDecoration: "underline",
                    border: "none",
                    backgroundColor: "#fff"
                };
                return <h5 className="d-flex center" style={buttonStyle} onClick={handleButtonClick}>Print</h5>;
            }
        },
    ])
    const handleBackClick = () => {
        window.history.back();
    }
    const handleReset = () => {
        const today = new Date();
        setFormData({
            DocType: "",
            fromDate: formatDate(today),
            toDate: formatDate(today),
            DocumentNo: "",
            filter: '',
            vendorName: "",
        });
        setDocTerm(null);
    }
    const handlenew = () => {
        navigate('/Inventory/Partial/Create');
    }
    const handleDateChange = async (input) => {
        const name = input?.target?.name || input.name;
        const value = input?.target?.value || input.value;

        const updatedValue = typeof value === 'string' ? value : formatDate(value);
        let updatedDates = { ...formData, [name]: updatedValue };
        setFormData(updatedDates);
    }
    const handlePrint = (docNo) => {
        if (docNo) {
            // dispatch(clearRows());
            const token = localStorage.getItem('Token');
            const DB = localStorage.getItem('DataBase');
            if (!token) {
                alert('Auth token is missing! Unable to proceed.');
                return;
            }
            const popupWidth = 1000;
            const popupHeight = 600;
            const popupLeft = (window.screen.width - popupWidth) / 2;
            const popupTop = (window.screen.height - popupHeight) / 2;
            const popup = window.open('', 'ReportPopup', `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`);

            if (popup) {
                const form = document.createElement('form');
                form.method = 'POST';
                form.action = REPORT_URL;
                form.target = 'ReportPopup';

                const inputs = [
                    { name: 'authToken', value: token },
                    { name: '_db', value: DB },
                    { name: 'reportName', value: "POrder" },
                    { name: 'voucherNo', value: docNo },
                ];

                inputs.forEach(({ name, value }) => {
                    const input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = name;
                    input.value = value;
                    form.appendChild(input);
                });

                document.body.appendChild(form);
                form.submit();
                document.body.removeChild(form);
            }
            // navigate(`/Inventory/Purchase/Order/${selectedRow?.recordId}`, { state: selectedRow })
        }
    };
    
    return (
        <div className='px-4 mt-4'>
            <div className="cost-center-section">
                <div className='border-box2 p-4 d-flex justify-content-between pt-3'>
                    <h5 className='col mainInvHead'>PO Cancellation/Closing</h5>
                    <div className='d-flex gap-3'>
                        {permissions?.canAdd === true ? (
                            <div className="col center">
                                <button className="mainbtn " type="submit" onClick={() => handlenew()}>
                                    <IoAddSharp color="#fff" className="center mt-1" /> <div>Add</div>
                                </button>
                            </div>
                        ) : (
                            ''
                        )}
                    </div>
                </div>
                <div className="d-flexcursor-pointer slide-header"
                    onClick={() => setPOTab(!POTab)}>
                    <div className='h6 pt-1'>PO Cancellation/Closing Filters</div>
                </div>
                <div className={`slide-content ${POTab ? 'open' : 'closed'}`}>
                    <div className={`border-box2 p-3 ${POTab ? 'slide-in' : 'slide-out'}`}>
                        <div className="form-group row pb-3">
                            <div className="d-flex justify-content-between col ">
                                <label htmlFor="validationCustom02" className="form-label  pt-1 start">Document No</label>
                                <input
                                    type="text"
                                    className="form-Input w-70"
                                    id="validationCustom02"
                                    name="DocumentNo"
                                    value={formData?.DocumentNo}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className='col d-flex justify-content-between'>
                                <label htmlFor="PropertyGroup" className="form-label  pt-2 start">Vendor Name</label>
                                <Select
                                    value={formData?.vendorName}
                                    className="w-100 p-0"
                                    options={suppliers?.map((sup) => ({ value: sup, label: sup?.supplierName }))}
                                    onChange={(selectedOption) => handleSupplierChange(selectedOption)}
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                />
                            </div>
                            <div className="d-flex justify-content-between col-md-4 col-lg-4">
                                <label htmlFor="validationCustom01" className="form-label  pt-1 start">Type</label>
                                <Select
                                    value={DocTerm}
                                    options={DocFilter}
                                    onChange={handleDocFilter}
                                    className="w-100 p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                />
                            </div>
                        </div>
                        <div className='row'>
                            <div className="d-flex justify-content-between start col">
                                <label className="form-label  pt-1 start">From Date</label>
                                <DatePicker
                                    selected={formData.fromDate}
                                    onChange={(date) => handleDateChange({ name: 'fromDate', value: date })}
                                    className="p-2 form-Input w-100"
                                    dateFormat="dd-MM-yyyy"
                                />
                            </div>
                            <div className="d-flex justify-content-between start col">
                                <label className="form-label  pt-1 start">to Date</label>
                                <DatePicker
                                    selected={formData.toDate}
                                    onChange={(date) => handleDateChange({ name: 'toDate', value: date })}
                                    className="p-2 form-Input w-100"
                                    dateFormat="dd-MM-yyyy"
                                />
                            </div>
                            <div className='col d-flex gap-5'>
                                <div className='w-50'>
                                    {loading === true ?
                                        <button className='mainbtnGry w-100' type="submit"><ClipLoader color="#ffffff" size={25} /></button> :
                                        <div onClick={() => fetchApprovalData()} className='mainbtnGry flex-end gap-2'>
                                            <IoSearch color='#fff' className='center mt-1 mx-2' />
                                            <div className='center'>Search</div>
                                        </div>
                                    }
                                </div>
                                <div className='w-50'>
                                    <button className='mainbtnRed w-100' onClick={handleReset} ><RiRefreshLine className='center mt-1 mx-2' /><div>Reset</div></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="cost-center-section">
                <div className="d-flex mt-3 cursor-pointer slide-header"
                    onClick={() => setSupplierTab(!SupplierTab)}>
                    <div className='h6 pt-1'>PO Cancellation/Closing List</div>
                </div>
                <div className={`slide-content ${SupplierTab ? 'open' : 'closed'}`}>
                    <div className={`border-box2 ${SupplierTab ? 'slide-in' : 'slide-out'}`}>
                        <div className="ag-theme-quartz" style={{ height: 500, suppressMovable: true, width: '100%' }}>
                            <AgGridReact
                                rowData={rowData}
                                columnDefs={colDefs}
                                rowSelection="multiple"
                                suppressRowClickSelection={true}
                                getRowStyle={(params) =>
                                    params.node.rowIndex % 2 === 0
                                        ? { background: "#F0EDF5" }
                                        : { background: "#fff" }
                                }
                            />
                        </div>
                        <Pagination pagination={pagination} getItems={fetchApprovalData} pageSize={pageSize} />
                    </div>
                </div>
            </div>
        </div >
    )
}

export default PartialPO;
